var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgNoResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 626,
    viewBox: "0 0 630 626",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18440_62259)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.34 0H100C44.7715 0 0 44.7715 0 100V424.658C68.8606 457.005 85.0453 497.563 92.6228 554.691C99.5646 607.026 132.559 618.654 168.712 626H500C571.797 626 630 567.797 630 496V228.218C599.204 222.45 560.26 208.189 534.069 173.604C515.156 148.629 515.054 124.552 514.957 101.72C514.801 64.9514 514.659 31.4135 435.989 2.56134C433.68 1.71561 431.465 0.861158 429.34 0Z",
    fill: "#151B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.08 683.014C261.08 683.014 242.06 631.701 179.208 596.418C116.275 561.136 64.836 618.233 42.0111 511.393C19.1862 404.553 -54.7466 391.084 -54.7466 391.084",
    stroke: "url(#paint0_linear_18440_62259)",
    strokeOpacity: 0.3,
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.131 240.699C678.131 240.699 655.223 200.128 607.341 171.456C563.18 145.014 493.051 161.127 477.504 131.546C448.146 76.1015 556.398 -5.45365 448.146 -46.0247",
    stroke: "url(#paint1_linear_18440_62259)",
    strokeOpacity: 0.3,
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18440_62259",
    x1: 44.5357,
    y1: 470.149,
    x2: 262.356,
    y2: 474.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0030FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18440_62259",
    x1: 520.443,
    y1: 31.6297,
    x2: 679.089,
    y2: 34.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0030FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DEFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18440_62259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 626,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNoResult);
export default __webpack_public_path__ + "static/media/bg-no-result.abf81955.svg";
export { ForwardRef as ReactComponent };